import React from "react";

export default function TemplateHelpDialog({ open, onClose }) {
  if (!open) return null;

  return (
    <div style={{ 
      position: "absolute", 
      background: "white", 
      border: "1px solid #ddd", 
      padding: 20, 
      zIndex: 11, 
      width: 700, 
      maxHeight: 500,
      overflowY: "auto",
      right: 0,
      top: "100%",
      marginTop: 5,
      boxShadow: "0 2px 8px rgba(0,0,0,0.15)"
    }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 15 }}>
        <strong style={{ fontSize: 16 }}>
          {I18n && I18n.t ? I18n.t("templates.help_title") : "Search Templates Help"}
        </strong>
        <a onClick={onClose} style={{ cursor: "pointer", fontSize: 14 }}>close</a>
      </div>
      <div style={{ lineHeight: 1.6, color: "#333" }}>
        <div style={{ marginBottom: 15 }}>
          <strong style={{ display: "block", marginBottom: 5, color: "#2c3e50" }}>
            {I18n && I18n.t ? I18n.t("templates.help_save_title") : "Saving Search Templates"}
          </strong>
          <p style={{ margin: 0 }}>
            {I18n && I18n.t ? I18n.t("templates.help_save_text") : 
              "You can save your search criteria as templates to quickly reuse them later. This is useful for searches you perform regularly, saving you time from re-entering the same parameters."}
          </p>
        </div>

        <div style={{ marginBottom: 15 }}>
          <strong style={{ display: "block", marginBottom: 5, color: "#2c3e50" }}>
            {I18n && I18n.t ? I18n.t("templates.help_ownership_title") : "Template Ownership"}
          </strong>
          <p style={{ margin: 0 }}>
            {I18n && I18n.t ? I18n.t("templates.help_ownership_text") : 
              "You can only delete templates that you created. However, you can view and use templates created by other users, making it easy to share common searches across your team."}
          </p>
        </div>

        <div style={{ marginBottom: 15 }}>
          <strong style={{ display: "block", marginBottom: 5, color: "#2c3e50" }}>
            {I18n && I18n.t ? I18n.t("templates.help_favourites_title") : "Favourite Templates"}
          </strong>
          <p style={{ margin: 0 }}>
            {I18n && I18n.t ? I18n.t("templates.help_favourites_text") : 
              "You can mark templates as favourites by clicking the star icon. Favourited templates appear at the top of the list for quick access. New templates you create are automatically marked as favourites."}
          </p>
        </div>

        <div style={{ marginBottom: 15 }}>
          <strong style={{ display: "block", marginBottom: 5, color: "#2c3e50" }}>
            {I18n && I18n.t ? I18n.t("templates.help_dates_title") : "Date Ranges"}
          </strong>
          <p style={{ margin: 0 }}>
            {I18n && I18n.t ? I18n.t("templates.help_dates_text") : 
              "Date ranges in templates are saved relative to the current date, not as absolute dates. For example, if you save a template with \"last 5 days\" selected, it will always search the most recent 5 days when applied, not the specific dates from when you first saved it. This ensures your searches stay current."}
          </p>
        </div>

        <div style={{ marginBottom: 0 }}>
          <strong style={{ display: "block", marginBottom: 5, color: "#2c3e50" }}>
            {I18n && I18n.t ? I18n.t("templates.help_scope_title") : "Template Scope"}
          </strong>
          <p style={{ margin: 0 }}>
            {I18n && I18n.t ? I18n.t("templates.help_scope_text") : 
              "Each search template is specific to the form where it was created. Templates saved on one search form will not appear on other search forms, as each form may have different search criteria."}
          </p>
        </div>
      </div>
    </div>
  );
}

